import { Fragment } from "react";
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    Transition,
    TransitionChild,
} from "@headlessui/react";
import {
    XMarkIcon,
} from "@heroicons/react/24/outline";
import {
    Button,
    Input,
    Select,
} from "components/ui";

export function TaxesFilterDrawer({ show, onClose }) {
    return (
        <Transition show={show} as={Fragment}>
            <Dialog as="div" className="relative z-[420]" onClose={onClose}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-slate-900/25 backdrop-blur-sm dark:bg-black/40" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-hidden text-left">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <TransitionChild
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <DialogPanel className="pointer-events-auto w-screen max-w-[320px]">
                                    <div className="flex h-full flex-col bg-white shadow-2xl dark:bg-dark-800 overflow-hidden border-l border-slate-100 dark:border-dark-600">
                                        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4 dark:border-dark-700 bg-slate-50/50">
                                            <DialogTitle className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-widest pl-1">
                                                Filter
                                            </DialogTitle>
                                            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-dark-200">
                                                <XMarkIcon className="h-5 w-5" />
                                            </button>
                                        </div>

                                        <div className="flex-1 px-6 py-6 space-y-6 overflow-y-auto no-scrollbar">
                                            <Select label="Filter profile" data={["Standard Filter"]} defaultValue="Standard Filter" />
                                            <Input label="Keyword" placeholder="Enter keyword" className="h-10" />
                                            <Input label="Agency" placeholder="Enter agency" className="h-10" />
                                            <Select label="Status" data={["All", "Active", "Inactive"]} defaultValue="All" />
                                        </div>

                                        <div className="p-4 border-t border-gray-100 dark:border-dark-700 flex items-center justify-between bg-gray-50/50 dark:bg-dark-900/50">
                                            <button className="text-[11px] font-bold text-primary hover:underline pl-1 transition-colors">Clear all</button>
                                            <Button variant="filled" color="primary" size="sm" className="font-bold text-xs h-9 px-6" onClick={onClose}>
                                                Apply filter
                                            </Button>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
